import { render, staticRenderFns } from "./JourneyDetails.vue?vue&type=template&id=7925c570&"
import script from "./JourneyDetails.vue?vue&type=script&lang=js&"
export * from "./JourneyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports